<div class="karaoke-container">
  <div>
    <ng-container *ngIf="showPromptImage()">
      <img
        src="assets/img/prompt-placeholder.png"
        alt="Cartoon Image asking you to discuss the following question"
      />
    </ng-container>
  </div>
  <ng-container
    *ngIf="
      karaoke?.transcriptWordList?.length && karaoke?.audioUrl?.length;
      else notFinished
    "
  >
    <div class="audio-container">
      <button
        (click)="loadAndPlay()"
        [disabled]="audio?.hasError"
        *ngIf="!audio?.hasStarted && !audio?.isPlaying"
      >
        <mat-icon fontSet="material-icons-outlined" mat-list-icon color="accent"
          >play_circle_filled</mat-icon
        >
      </button>
      <button
        (click)="resume()"
        [disabled]="audio?.hasError"
        *ngIf="audio?.hasStarted && !audio?.isPlaying"
      >
        <mat-icon
          fontSet="material-icons-outlined"
          color="primary"
          mat-list-icon
          >play_circle_filled</mat-icon
        >
      </button>

      <button (click)="pause()" *ngIf="audio?.isPlaying">
        <mat-icon
          fontSet="material-icons-outlined"
          color="primary"
          mat-list-icon
          >pause_circle_filled</mat-icon
        >
      </button>

      <button
        (click)="restart()"
        [disabled]="!audio?.hasStarted || audio?.hasError"
      >
        <ng-container
          *ngIf="audio?.hasStarted && !audio?.hasError; else disabled"
        >
          <mat-icon
            color="primary"
            fontSet="material-icons-outlined"
            mat-list-icon
            >replay_circle_filled</mat-icon
          >
        </ng-container>
        <ng-template #disabled>
          <mat-icon
            class="disabled"
            fontSet="material-icons-outlined"
            mat-list-icon
            >replay_circle_filled</mat-icon
          >
        </ng-template>
      </button>
    </div>
    <div class="transcript-container">
      <app-transcript
        [currentTime]="currentTime"
        [transcriptWordList]="karaoke.transcriptWordList"
      ></app-transcript>
    </div>
  </ng-container>
</div>
<ng-template #notFinished>
  <div class="v-container">
    <div class="row">
      <p>The audio file is still processing</p>
    </div>
    <div class="row">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
</ng-template>
